import Typography from 'typography'

import { BrandColors, BrandColorsV2 } from '../utilities/Colors'

export const FontFamily = {
  brandCode: `'FlatfileDiatypeMono', 'PT Mono', 'Operator Mono', 'Fira Code', 'Fira Mono', 'Roboto Mono', monospace`,
  brandPrimary: `'FlatfileDiatypeVariable', -apple-system, BlinkMacSystemFont,
  'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif`,
  brandPrimaryHeading: `'FlatfileDiatypeVariable', -apple-system, BlinkMacSystemFont,
  'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif`,
  brandSerif: `'FlatfileDiatypeVariable', Georgia, serif`,
  mikro: `'Mikro', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif`
}

const colors = {
  code: {
    // tokens
    add: BrandColors.pinata900,

    // ui
    bg: `#1b191f`,
    // another meh
    bgInline: BrandColors.pigeon100,

    border: BrandColors.pigeon200,

    comment: BrandColors.pigeon100,

    copyButton: BrandColors.pigeon100,

    cssString: BrandColors.pinata900,
    invisibles: `#e0d7d1`,
    keyword: BrandColors.primary,
    lineHighlightBackground: BrandColors.pigeon100,
    lineHighlightBorder: BrandColors.electric700,
    punctuation: BrandColors.pigeon100,
    regex: `#d88489`,
    remove: BrandColors.pinata900,
    selector: BrandColors.primary,
    tag: BrandColors.primary,
    text: BrandColors.pigeon800
  }
}

export const Typescale = {
  // button: 0.9375,
  button: 1.125,
  description: 0.8125,
  descriptionSmall: 0.75,
  display: 3,
  displaySmall: 2,
  displayXXL: 3.875,
  label: 0.75,
  labelLarge: 0.875,
  labelTiny: 0.625,
  labelXL: 1,
  lead: 1.3125,
  leadSm: 1.125,
  leadXL: 1.5,
  paragraph: 1,
  paragraphLarge: 1.125,
  paragraphSmall: 0.875,
  title: 1.25,
  titleLarge: 1.5,
  titleSmall: 1.125,
  titleXL: 2,
  titleXS: 1,
  titleXXL: 2.375,

  // Base font size: 16px / 1rem
  titleH1: 3.75,
  titleH2: 2.25,
  titleH3: 1.875,
  titleH4: 1.25,
  titleH5: 1.125,
  titleH6: 1,
  body1: 1.5,
  body2: 1.25,
  body3: 1,
  topHat: 0.9375,
  action: 1.125,
  actionLarge: 1.25,
  actionSmall: 1,
  caption: 0.875,
  captionSmall: 0.6875,
  link: 1,
  linkLarge: 1.125,
  linkSmall: 0.875,
  linkXS: 0.6875
}

export const codeCSS = {
  ".gatsby-highlight pre[class*='language-']": {
    WebkitOverflowScrolling: `touch`,
    border: 0,
    marginBottom: 0,
    overflow: 'auto',
    padding: '2.5rem 0 1.5rem'
  },
  ".gatsby-highlight pre[class*='language-'] code": {
    display: 'block',
    padding: '0 1.5rem'
  },
  '.gatsby-highlight button': {
    fontFamily: FontFamily.brandPrimary,
    position: 'absolute',
    right: '0.25rem',
    top: '0.25rem',
    transition: 'all 0.2s ease-in-out'
  },
  ".gatsby-highlight pre[class*='language-']::before": {
    fontFamily: FontFamily.brandPrimary,
    fontSize: '0.75rem',
    fontWeight: '600',
    left: '1.5rem',
    letterSpacing: '0.125em',
    padding: '0 0.75rem',
    position: `absolute`,
    textAlign: `right`,
    textTransform: `uppercase`,
    top: `0`
  },
  ".gatsby-highlight pre[class='language-javascript']::before": {
    background: BrandColors.pigeon200,
    color: BrandColors.pigeon800,
    content: `'js'`
  },
  ".gatsby-highlight pre[class='language-js']::before": {
    background: BrandColors.pigeon200,
    color: BrandColors.pigeon800,
    content: `'js'`
  },
  ".gatsby-highlight pre[class='language-jsx']::before": {
    background: BrandColors.pigeon200,
    color: BrandColors.pigeon800,
    content: `'jsx'`
  },
  ".gatsby-highlight pre[class='language-typescript']::before": {
    background: BrandColors.pigeon200,
    color: BrandColors.pigeon800,
    content: `'ts'`
  },
  ".gatsby-highlight pre[class='language-ts']::before": {
    background: BrandColors.pigeon200,
    color: BrandColors.pigeon800,
    content: `'ts'`
  },
  ".gatsby-highlight pre[class='language-tsx']::before": {
    background: BrandColors.pigeon200,
    color: BrandColors.pigeon800,
    content: `'tsx'`
  },
  ".gatsby-highlight pre[class='language-html']::before": {
    background: BrandColors.pigeon200,
    color: BrandColors.pigeon800,
    content: `'html'`
  },
  ".gatsby-highlight pre[class='language-css']::before": {
    background: BrandColors.pigeon200,
    color: BrandColors.pigeon800,
    content: `'css'`
  },
  ".gatsby-highlight pre[class='language-mdx']::before": {
    background: BrandColors.pigeon200,
    color: BrandColors.pigeon800,
    content: `'mdx'`
  },
  ".gatsby-highlight pre[class='language-shell']::before": {
    background: BrandColors.pigeon200,
    color: BrandColors.pigeon800,
    content: `'shell'`
  },
  ".gatsby-highlight pre[class='language-sh']::before": {
    background: BrandColors.pigeon200,
    color: BrandColors.pigeon800,
    content: `'sh'`
  },
  ".gatsby-highlight pre[class='language-bash']::before": {
    background: BrandColors.pigeon200,
    color: BrandColors.pigeon800,
    content: `'bash'`
  },
  ".gatsby-highlight pre[class='language-markdown']::before": {
    background: BrandColors.pigeon200,
    color: BrandColors.pigeon800,
    content: `'md'`
  },
  ".gatsby-highlight pre[class='language-json']::before, .gatsby-highlight pre[class='language-json5']::before":
    {
      background: BrandColors.pigeon200,
      color: BrandColors.pigeon800,
      content: `'json'`
    },
  ".gatsby-highlight pre[class='language-diff']::before": {
    background: `#e6ffed`,
    content: `'diff'`
  },
  ".gatsby-highlight pre[class='language-text']::before": {
    content: `'text'`
  },
  ".gatsby-highlight pre[class='language-flow']::before": {
    background: `#E8BD36`,
    content: `'flow'`
  },
  '.gatsby-highlight': {
    position: 'relative'
  },
  '.gatsby-highlight pre': {
    padding: '2.5rem 1.5rem 1rem'
  },
  '.gatsby-highlight pre code': {
    display: `block`,
    float: `left`,
    fontSize: `100%`,
    lineHeight: 1.5,
    // reset code vertical padding declared earlier
    padding: `0 1.5rem`
  },
  '.gatsby-highlight pre::-webkit-scrollbar': {
    cursor: 'drag',
    height: '0.5rem',
    width: '0.5rem'
  },
  '.gatsby-highlight pre::-webkit-scrollbar-thumb': {
    background: 'rgba(61, 143, 209, 0.9)'
  },
  '.gatsby-highlight pre::-webkit-scrollbar-track': {
    background: 'rgba(61, 143, 209, 0.3)'
  },
  '.gatsby-highlight-code-line': {
    background: colors.code.lineHighlightBackground,
    borderLeft: `1px solid ${colors.code.lineHighlightBorder}`,
    display: `block`,
    marginLeft: `-1.5rem`,
    marginRight: `-1.5rem`,
    paddingLeft: `1rem`,
    paddingRight: `1.5rem`
  },
  'div.gatsby-highlight': {
    borderRadius: '0.5rem',
    marginBottom: '2rem',
    overflow: 'hidden'
  },
  pre: {
    borderRadius: '0.5rem',
    overflow: 'hidden'
  },
  'pre > span': {
    maxWidth: '100%',
    overflow: 'hidden'
  },
  'pre > span > code': {
    borderRadius: 0,
    padding: '1rem !important'
  }
}

export const DocsTypography = new Typography({
  baseFontSize: '1.1875rem',
  baseLineHeight: 1.8,
  boldWeight: 600,
  headerFontFamily: [
    ...FontFamily.brandPrimaryHeading.split(',').map(font => font.trim())
  ],
  headerWeight: 600,
  overrideStyles: ({ rhythm }) => ({
    a: {
      color: BrandColors.sky600
    },
    h1: {
      marginBottom: rhythm(14 / 16)
    },
    h2: {
      fontSize: '1.8rem',
      fontWeight: 500,
      marginBottom: rhythm(10 / 16)
    },
    h3: {
      marginBottom: rhythm(10 / 16)
    },
    h4: {
      marginBottom: rhythm(10 / 16)
    },
    h5: {
      marginBottom: rhythm(10 / 16)
    },
    h6: {
      marginBottom: rhythm(10 / 16)
    },
    hr: {
      backgroundColor: BrandColors.pigeon200,
      marginBottom: '3rem',
      marginTop: '3.5rem'
    },
    img: {
      marginBottom: rhythm(8 / 16),
      marginTop: rhythm(8 / 16)
    },
    ol: {
      listStyleType: 'decimal'
    },
    strong: {
      color: BrandColors.pigeon800,
      wordBreak: 'break-all'
    },
    'td:first-child, th:first-child': {
      paddingLeft: '1.2rem'
    },
    ul: {
      listStyleType: 'disc'
    },
    ...codeCSS
  }),
  scaleRatio: 2.5
})

export const PluginsTypography = new Typography({
  baseFontSize: '1.1875rem',
  baseLineHeight: 1,
  boldWeight: 600,
  headerFontFamily: [
    ...FontFamily.brandPrimaryHeading.split(',').map(font => font.trim())
  ],
  headerWeight: 600,
  overrideStyles: ({ rhythm }) => ({
    h1: {
      fontFamily: FontFamily.brandSerif,
      lineHeight: 1.8,
      marginBottom: rhythm(14 / 16)
    },
    h2: {
      lineHeight: 1.8,
      marginBottom: rhythm(1.5)
    },
    h3: {
      lineHeight: 1.8,
      marginBottom: rhythm(10 / 16)
    },
    h4: {
      lineHeight: 1.8,
      marginBottom: rhythm(10 / 16)
    },
    h5: {
      lineHeight: 1.8,
      marginBottom: rhythm(10 / 16)
    },
    h6: {
      lineHeight: 1.8,
      marginBottom: rhythm(10 / 16)
    },
    img: {
      marginBottom: rhythm(8 / 16)
    },
    ol: {
      listStyleType: 'decimal'
    },
    p: {
      marginBottom: '2rem'
    },
    'p code': {
      backgroundColor: 'rgb(237, 242, 255) !important',
      color: 'rgb(66, 78, 88) !important',
      display: 'inline-block',
      fontSize: '0.925rem !important',
      lineHeight: '1 !important',
      padding: '0.3em !important',
      whiteSpace: 'pre-line'
    },
    pre: {
      padding: '1.5rem'
    },
    'pre code': {
      lineHeight: 1.5
    },
    'span code': {
      fontSize: '1rem'
    },
    'table + p': {
      marginTop: '2rem'
    },
    ul: {
      listStyleType: 'disc'
    },
    ...codeCSS,
    iframe: {
      display: 'block',
      marginLeft: 'auto',
      marginRight: 'auto',
      maxWidth: '100%'
    }
  }),
  scaleRatio: 2.5
})

export const WhatsNewTypography = new Typography({
  baseFontSize: '1rem',
  baseLineHeight: 1,
  boldWeight: 500,
  headerFontFamily: [
    ...FontFamily.brandPrimary.split(',').map(font => font.trim())
  ],
  headerWeight: 400,
  overrideStyles: ({ rhythm }) => ({
    h1: {
      lineHeight: 1.8,
      marginBottom: rhythm(14 / 16)
    },
    h2: {
      lineHeight: 1.25,
      fontSize: '2.25rem',
      marginBottom: rhythm(1.5),
      marginTop: rhythm(40 / 16)
    },
    h3: {
      lineHeight: 1.25,
      fontSize: '1.5rem',
      marginBottom: rhythm(20 / 16),
      marginTop: rhythm(40 / 16)
    },
    h4: {
      lineHeight: 1.25,
      fontSize: '1.25rem',
      marginBottom: rhythm(10 / 16)
    },
    h5: {
      lineHeight: 1.25,
      fontSize: '1.125rem',
      marginBottom: rhythm(10 / 16)
    },
    h6: {
      lineHeight: 1.25,
      fontSize: '1rem',
      marginBottom: rhythm(10 / 16)
    },
    img: {
      marginBottom: rhythm(8 / 16)
    },
    ol: {
      listStyleType: 'decimal'
    },
    p: {
      marginBottom: '1.5rem',
      color: BrandColorsV2.gray11,
      fontSize: '1rem',
      fontFamily: FontFamily.brandPrimary
    },
    a: {
      color: '#111 !important',
      borderBottom: '1px solid',
      borderColor: BrandColors.black,
      fontWeight: 500
    },
    'a:hover': {
      color: '#333 !important',
      borderBottom: '1px solid',
      borderColor: '#333 !important',
      fontWeight: 500
    },
    'p code': {
      backgroundColor: 'rgb(237, 242, 255) !important',
      color: 'rgb(66, 78, 88) !important',
      display: 'inline-block',
      fontSize: '0.925rem !important',
      lineHeight: '1 !important',
      padding: '0.3em !important',
      whiteSpace: 'pre-line'
    },
    pre: {
      padding: '1.5rem'
    },
    'pre code': {
      lineHeight: 1.5
    },
    'span code': {
      fontSize: '1rem'
    },
    'table + p': {
      marginTop: '2rem'
    },
    ul: {
      listStyleType: 'disc'
    },
    li: {
      marginBottom: '0.25rem'
    },
    ...codeCSS,
    iframe: {
      display: 'block',
      marginLeft: 'auto',
      marginRight: 'auto',
      maxWidth: '100%'
    }
  }),
  scaleRatio: 2.5
})

export const PrivacyTypography = new Typography({
  baseFontSize: '1rem',
  baseLineHeight: 1,
  boldWeight: 500,
  headerFontFamily: [
    ...FontFamily.brandPrimary.split(',').map(font => font.trim())
  ],
  headerWeight: 400,
  overrideStyles: ({ rhythm }) => ({
    h1: {
      lineHeight: '100%',
      fontSize: '2.875rem',
      marginBottom: rhythm(14 / 16),
      letterSpacing: '-1.8px'
    },
    h2: {
      lineHeight: 1.625,
      fontSize: '1.375rem',
      marginBottom: rhythm(10 / 16),
      letterSpacing: '-0.5px'
    },
    h3: {
      lineHeight: 1.625,
      fontSize: '1.375rem',
      marginBottom: rhythm(10 / 16),
      letterSpacing: '-0.5px'
    },
    h4: {
      // line height 26px to number = 1.625
      lineHeight: 1.625,
      fontSize: '1.375rem',
      marginBottom: rhythm(10 / 16),
      letterSpacing: '-0.5px'
    },
    h5: {
      // line height 24px to number = 1.5
      lineHeight: 1.5,
      fontSize: '1.125rem',
      marginBottom: rhythm(10 / 16),
      letterSpacing: '-0.25px'
    },
    h6: {
      lineHeight: 1.25,
      fontSize: '1rem',
      marginBottom: rhythm(10 / 16),
      letterSpacing: '0px'
    },
    img: {
      marginBottom: rhythm(8 / 16)
    },
    ol: {
      listStyleType: 'decimal'
    },
    p: {
      marginBottom: '1.5rem',
      color: '#565656',
      fontSize: '1rem',
      fontFamily: FontFamily.brandPrimary
    },
    'p code': {
      backgroundColor: 'rgb(237, 242, 255) !important',
      color: 'rgb(66, 78, 88) !important',
      display: 'inline-block',
      fontSize: '0.925rem !important',
      lineHeight: '1 !important',
      padding: '0.3em !important',
      whiteSpace: 'pre-line'
    },
    pre: {
      padding: '1.5rem'
    },
    'pre code': {
      lineHeight: 1.5
    },
    'span code': {
      fontSize: '1rem'
    },
    'table + p': {
      marginTop: '2rem'
    },
    ul: {
      listStyleType: 'disc'
    },
    li: {
      marginBottom: '0.25rem'
    },
    ...codeCSS,
    iframe: {
      display: 'block',
      marginLeft: 'auto',
      marginRight: 'auto',
      maxWidth: '100%'
    }
  }),
  scaleRatio: 2.5
})

const BlogTypography = new Typography({
  baseFontSize: '1rem',
  baseLineHeight: 1,
  boldWeight: 500,
  headerFontFamily: [
    ...FontFamily.brandPrimary.split(',').map(font => font.trim())
  ],
  headerWeight: 400,
  overrideStyles: ({ rhythm }) => ({
    h1: {
      lineHeight: 1.8,
      marginBottom: rhythm(14 / 16)
    },
    h2: {
      lineHeight: 1.25,
      fontSize: '2.25rem',
      marginBottom: rhythm(1.5),
      marginTop: rhythm(40 / 16)
    },
    h3: {
      lineHeight: 1.25,
      fontSize: '1.5rem',
      marginBottom: rhythm(20 / 16),
      marginTop: rhythm(40 / 16)
    },
    h4: {
      lineHeight: 1.25,
      fontSize: '1.25rem',
      marginBottom: rhythm(10 / 16)
    },
    h5: {
      lineHeight: 1.25,
      fontSize: '1.125rem',
      marginBottom: rhythm(10 / 16)
    },
    h6: {
      lineHeight: 1.25,
      fontSize: '1rem',
      marginBottom: rhythm(10 / 16)
    },
    img: {
      marginBottom: rhythm(8 / 16)
    },
    ol: {
      listStyleType: 'decimal'
    },
    p: {
      marginBottom: '1.5rem',
      color: BrandColorsV2.gray11,
      fontSize: '1rem',
      fontFamily: FontFamily.brandPrimary
    },
    'p code': {
      backgroundColor: 'rgb(237, 242, 255) !important',
      color: 'rgb(66, 78, 88) !important',
      display: 'inline-block',
      fontSize: '0.925rem !important',
      lineHeight: '1 !important',
      padding: '0.3em !important',
      whiteSpace: 'pre-line'
    },
    pre: {
      padding: '1.5rem'
    },
    'pre code': {
      lineHeight: 1.5
    },
    'span code': {
      fontSize: '1rem'
    },
    'table + p': {
      marginTop: '2rem'
    },
    ul: {
      listStyleType: 'disc'
    },
    li: {
      marginBottom: '0.25rem'
    },
    ...codeCSS,
    iframe: {
      display: 'block',
      marginLeft: 'auto',
      marginRight: 'auto',
      maxWidth: '100%'
    }
  }),
  scaleRatio: 2.5
})

export default BlogTypography
